// @flow
import * as React from 'react';
import ArchivedBoardList from 'app/common/react/components/profile/ProfileBoards/ArchivedBoardList';
import ConnectViewer from 'app/common/react/components/common/ConnectViewer/ConnectViewer';
import ProfileBoardsGroupHeader from 'app/common/react/components/profile/ProfileBoards/ProfileBoardsGroupHeader';
import ProfileBoardsList from 'app/common/react/components/profile/ProfileBoards/ProfileBoardsList';
import type { AuthViewer } from 'app/packages/pinterest-flow-types/viewer';
import type { BoardGroup } from 'app/common/react/components/profile/ProfileBoards/BoardGroup';
import type { BoardSortOptionsType } from 'app/packages/pinterest-flow-types/user';
import type { DesktopProfileBoard } from 'app/packages/pinterest-flow-types/board';
import type { ProfileBoardCardLayout } from 'app/common/react/components/profile/ProfileBoardCard/layout';
import { Box } from 'gestalt';

type Props = {|
  boardIds: Array<string>,
  boardOrder?: BoardSortOptionsType,
  group: BoardGroup,
  isOverview: boolean,
  isOwnProfile: boolean,
  isPartner: boolean,
  isUserBlocked: boolean,
  onBoardChange: () => void,
  onBoardCreate: (board: DesktopProfileBoard) => void,
  onBoardGroupChange: () => void,
  profileBoardView: 'list' | ProfileBoardCardLayout,
  showCreatorProfile: boolean,
|};

export default function ProfileBoardGroup(props: Props) {
  const {
    boardIds,
    boardOrder,
    group,
    isOverview,
    isOwnProfile,
    isPartner,
    isUserBlocked,
    onBoardChange,
    onBoardCreate,
    onBoardGroupChange,
    profileBoardView: layout,
    showCreatorProfile,
  } = props;

  if (group === 'archived') {
    return (
      <Box>
        <ProfileBoardsGroupHeader type="archived" />
        <ArchivedBoardList
          boardIds={boardIds}
          layout={layout}
          onBoardArchiveChange={onBoardGroupChange}
          onBoardDelete={onBoardChange}
          showCreatorProfile={showCreatorProfile}
        />
      </Box>
    );
  }

  const boardList = (
    <ConnectViewer>
      {(viewer: AuthViewer) => (
        <ProfileBoardsList
          boardIds={boardIds}
          boardOrder={boardOrder}
          buyablePins={[]}
          grouping={group}
          isOverview={isOverview}
          isOwnProfile={isOwnProfile}
          isUserBlocked={isUserBlocked}
          layout={layout}
          onBoardArchiveChange={onBoardGroupChange}
          onBoardCreate={onBoardCreate}
          onBoardDelete={onBoardChange}
          onBoardPrivacyChange={onBoardGroupChange}
          onBoardLeave={(boardId) => onBoardGroupChange()}
          onBoardReorder={onBoardChange}
          onBoardUpdate={onBoardChange}
          showCreatorProfile={showCreatorProfile}
          shouldShowBoardCreateCard={
            isOwnProfile &&
            !isOverview &&
            group !== 'protected' &&
            layout !== 'list' &&
            viewer.isAuth &&
            (boardIds.length === 0 || isPartner)
          }
        />
      )}
    </ConnectViewer>
  );

  return group === 'unlabeled' ? (
    boardList
  ) : (
    <Box
      dangerouslySetInlineStyle={{ __style: { backgroundColor: '#f7f7f7' } }}
      marginTop={6}
      marginBottom={6}
      overflow="hidden"
    >
      <ProfileBoardsGroupHeader type={group} />
      {boardList}
    </Box>
  );
}
